import { QueryClient } from '@tanstack/vue-query'
import { shouldRetryQuery } from './retry.ts'

export default new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetryQuery,
    },
  },
})
